import React from 'react';
import {
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';
import URI from 'urijs';
import cx from 'classnames';

const PropertyClassDropdown = ({
  className,
  propertyClass,
  basePath,
  propertyTypeMap,
  counts,
  BS,
  query = {}
}) => (
  <InputGroup className={cx(className, BS.inputGroupGutter, BS.pb2)}>
    <UncontrolledButtonDropdown>
      <DropdownToggle color="dark-blue" outline caret>
        {propertyTypeMap[propertyClass]}
        {counts && counts[propertyClass] !== undefined && ` (${counts[propertyClass]})`}
      </DropdownToggle>
      <DropdownMenu>
        {Object.keys(propertyTypeMap).map((key, i) => {
          if (parseInt(query.recentlySold, 10) === 1 && key === 'rental') {
            return null;
          }

          return (
            <LinkContainer
              to={URI(basePath)
                .search({
                  ...query,
                  propertyClass: key === 'residential' ? undefined : key
                })
                .toString()}
              isActive={() => propertyClass === key}
              key={i}
            >
              <DropdownItem>
                {propertyTypeMap[key]}
                {counts && counts[key] !== undefined && ` (${counts[key]})`}
              </DropdownItem>
            </LinkContainer>
          );
        })}
      </DropdownMenu>
    </UncontrolledButtonDropdown>
    <span className={cx(BS.ml2, BS.mr3)}>|</span>
  </InputGroup>
);

export default PropertyClassDropdown;



// WEBPACK FOOTER //
// ./src/partials/property/property-class-dropdown.js